import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: async () => (await import('./translations/en')).default,
  },
  zh: {
    translation: async () => (await import('./translations/zh')).default,
  },
  ua: {
    translation: async () => (await import('./translations/ua')).default,
  },
};

const getDefaultLocale = () => {
  return localStorage.getItem('lang') || 'en';
};

const loadLocale = async locale => {
  if (!resources[locale]) return;
  const translations = await resources[locale].translation();
  i18n.addResourceBundle(locale, 'translation', translations, true, true);
};

i18n.use(initReactI18next).init({
  lng: getDefaultLocale(),
  fallbackLng: 'en',
  debug: false,
  interpolation: { escapeValue: false },
  resources: {},
});

loadLocale(getDefaultLocale());

export default i18n;
